import { Reducer } from 'redux';

export default function reducerFactory(reducerMap: any, defaultState: any = {}): Reducer {
  return (state = defaultState, action) => {
    const reducer = reducerMap[action.type];
    return reducer ? reducer(state, action) : state;
  };
}
